



















// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Constants
import Assets from '@/constants/assets.ts';
import Endpoints from '@/constants/endpoints';

// Views
import InfoView from '@/shared/views/info.view.vue';


@Component({
    components: {
        InfoView,
    },
    computed: {
        ...mapGetters({
            currentBudget: 'getCurrentBudgetAcceptance',
        }),
    },
})
export default class DownloadView extends Vue {
    @Prop({ default: undefined }) private literals !: any;
    private currentBudget!: any;
    private assets = Assets;
    private endpoints = Endpoints;
    private getPurchase !: any;
    private getCompanion !: any;
    private literalsStatic = {
        title: '¡Aceptación de alta completada!',
        subtitle: 'Enhorabuena, has finalizado con éxito el proceso de aceptación de alta. ' +
                'Puedes descargar el documento con el resumen de tu alta pinchando en el siguiente enlace:',
    };


    get backgroundImage() {
        return {
            'background-image': `url("${this.assets.circleBlueGreen}")`,
            'background-repeat': 'no-repeat',
            'background-size': '400px 400px',
        };
    }

    get budgetUrl() {
        let val = Endpoints.budgetDocument(this.currentBudget.id);
        if (this.currentBudget.document) {
            val = this.currentBudget.document;
        }
        return val;
    }

    get getLiterals() {
        let literals = this.literalsStatic;
        if ( this.literals ) {
            literals = this.literals;
        }
        return literals;
    }
}
